import React from 'react';
import { FieldConfigLabelSection } from './components/FieldConfigLabelSection';
import { FieldConfigStyleTypeSection } from './components/FieldConfigStyleTypeSection';
import { FieldConfigShowTitleSection } from './components/FieldConfigShowTitleSection';
import { FieldConfigExclusionsSection } from './components/FieldConfigExclusionsSection';

interface FractionFieldConfigProps {
  label: string;
  onLabelChange: (value: string) => void;
  exclusionType: 'hide' | 'disable';
  onExclusionChange: (type: 'hide' | 'disable') => void;
  showTitle?: boolean;
  onShowTitleChange?: (value: boolean) => void;
  displayName?: string;
  onDisplayNameChange?: (value: string) => void;
}

const FractionFieldConfig: React.FC<FractionFieldConfigProps> = ({ label, onLabelChange, exclusionType, onExclusionChange, showTitle = true, onShowTitleChange, displayName = '', onDisplayNameChange }) => {
  return (
    <div>
      <FieldConfigLabelSection label={label} placeholderSuffix="Field label" />
      <FieldConfigStyleTypeSection fieldTypeName="Fraction Field" />
      <FieldConfigShowTitleSection
        showTitle={showTitle}
        onShowTitleChange={onShowTitleChange}
        displayName={displayName}
        onDisplayNameChange={onDisplayNameChange}
      />
      <FieldConfigExclusionsSection
        exclusionType={exclusionType}
        onExclusionChange={onExclusionChange}
      />
    </div>
  );
};

export default FractionFieldConfig;
